import React from "react";

// Stylised cross-border market map. Atlas is NOT Germany-centric: the hub is a
// neutral ATLAS node at the centre, connecting equally to every active market.
// Concept: ATLAS → European markets → sources → vehicle opportunities.
const NODES = [
  { id: "PT", label: "Portugal", x: 78, y: 262 },
  { id: "ES", label: "Spain", x: 120, y: 258 },
  { id: "FR", label: "France", x: 158, y: 205 },
  { id: "BE", label: "Belgium", x: 182, y: 152 },
  { id: "NL", label: "Netherlands", x: 192, y: 126 },
  { id: "DE", label: "Germany", x: 232, y: 158 },
  { id: "AT", label: "Austria", x: 258, y: 196 },
  { id: "IT", label: "Italy", x: 256, y: 240 },
  { id: "PL", label: "Poland", x: 296, y: 142 },
];

const HUB = { x: 200, y: 185 };

export const EuropeMap = ({ className = "", onSelect, ns = "" }) => (
  <svg viewBox="0 0 380 320" className={className} data-testid="europe-map" role="img" aria-label="European market coverage">
    <defs>
      <radialGradient id="land" cx="55%" cy="45%" r="60%">
        <stop offset="0%" stopColor="#1E3A5F" stopOpacity="0.55" />
        <stop offset="100%" stopColor="#0A1A2F" stopOpacity="0" />
      </radialGradient>
    </defs>
    <ellipse cx="200" cy="180" rx="170" ry="130" fill="url(#land)" />

    {/* Every market connects to the neutral ATLAS hub, not to a country */}
    {NODES.map((n) => (
      <line key={n.id} x1={HUB.x} y1={HUB.y} x2={n.x} y2={n.y}
        stroke="#3B82F6" strokeOpacity="0.24" strokeWidth="1" />
    ))}

    {/* Market nodes */}
    {NODES.map((n, i) => (
      <g key={n.id} onClick={onSelect ? () => onSelect(n.label) : undefined}
        style={{ cursor: onSelect ? "pointer" : "default" }}
        data-testid={`map-node-${ns}${n.id}`}>
        {onSelect && <circle cx={n.x} cy={n.y} r="14" fill="transparent" />}
        <circle cx={n.x} cy={n.y} r="5" fill="#60A5FA" fillOpacity="0.18" />
        <circle className="atlas-node" style={{ animationDelay: `${i * 0.25}s`, transformBox: "fill-box" }}
          cx={n.x} cy={n.y} r="2.5" fill="#3B82F6" />
        <text x={n.x} y={n.y - 10} textAnchor="middle"
          className="font-mono" fontSize="8" fill="#CBD5E1" fillOpacity="0.8">{n.id}</text>
      </g>
    ))}

    {/* Neutral ATLAS hub at the centre */}
    <g data-testid={`map-hub-${ns}atlas`}>
      <circle cx={HUB.x} cy={HUB.y} r="13" fill="#3B82F6" fillOpacity="0.16" />
      <circle cx={HUB.x} cy={HUB.y} r="6" fill="#93C5FD" />
      <text x={HUB.x} y={HUB.y + 24} textAnchor="middle"
        className="font-mono" fontSize="8.5" fill="#93C5FD" letterSpacing="1.5">ATLAS</text>
    </g>
  </svg>
);
